/**************************************************
 * Nombre:       Tarjeta_Empresa_Envio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Radio, Typography, useMediaQuery} from "@mui/material";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {theme} from "../../Tema";

const Tarjeta_Empresa_Envio = ({item, index, escogida}) => {
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            size={12}
            sx={{border: 1, borderRadius: 2, borderColor: '#00000050'}}
        >



            <Grid item container size={7} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="flex-start"
                    size={12}
                    sx={{pl: sCell ? 2 : 1}}
                >
                    <Grid item container size={12} sx={{justifyContent: 'flex-start',mt: 0.5}}>
                        <Typography sx={{fontWeight: 800, fontSize: sCell ? 14 : 18, lineHeight: 1.2}}>{item.carrier}</Typography>
                    </Grid>

                    <Grid item container size={12} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 600, fontSize: sCell ? 10 : 12, color: '#00000090'}}>Tiempo: <span
                            style={{
                                paddingRight: 10,
                                fontWeight: 500
                            }}>{`${item.delivery_days} dias`}</span></Typography>
                    </Grid>

                    <Grid item container size={12} sx={{justifyContent: 'flex-start', marginTop:0.2,mb: 1}}>
                        <Typography sx={{fontWeight: 600, fontSize: sCell ? 10 : 12, color: '#00000090', lineHeight: 1.1}}>Tipo: <span
                            style={{paddingRight: 10, fontWeight: 500}}>{item.service_type}</span></Typography>
                    </Grid>


                </Grid>
            </Grid>

            <Grid item container size={3} sx={{justifyContent: 'flex-end'}}>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="flex-start"
                >

                    <Grid item container size={12} sx={{justifyContent: 'flex-end'}}>
                        <Typography sx={{color: '#00000090', fontSize: sCell ? 12 : 14}}>Precio</Typography>
                    </Grid>

                    <Grid item container size={12} sx={{justifyContent: 'flex-end', marginTop: -0.5}}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: sCell ? 14 : 16
                            }}>{formatoMoneda(item.total_cost)}</Typography>
                    </Grid>

                </Grid>
            </Grid>

            <Grid item container size={2} sx={{justifyContent: 'center'}}>

                <Radio value={item.token} checked={escogida.token === item.token} sx={{justifyContent: 'flex-end', pl: 3}}/>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Empresa_Envio    